<template>
  <div class="mt-4">
    <div
      v-if="!subCategories"
      class="buttons d-flex justify-center align-center flex-wrap"
    >
      <v-btn
        @click="
          $router.push({
            name: 'SpeciesCategory',
            params: { categoryNameUrl: category.url }
          })
        "
        class="mb-5 ml-5"
        elevation="2"
        color="primary"
        v-for="category in categories"
        :key="category.id"
        >{{ category.name }}</v-btn
      >
    </div>
    <div
      v-if="subCategories"
      class="buttons d-flex justify-center align-center flex-wrap"
    >
      <v-btn
        v-if="activeSubCategoryName"
        class="mb-5 ml-5"
        elevation="2"
        color="primary"
        @click="
          $router.push({
            name: 'SpeciesCategory',
            params: { categoryNameUrl: categories[0].category_url }
          })
        "
      >
        <v-icon color="white">mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn
        @click="
          $router.push({
            name: 'SpeciesSubCategory',
            params: {
              categoryNameUrl: category.category_url,
              subCategoryNameUrl: category.sub_category_url
            }
          })
        "
        :outlined="category.sub_category_url === activeSubCategoryName"
        class="mb-5 ml-5"
        elevation="2"
        color="primary"
        v-for="category in categories"
        :key="category.id"
        >{{ category.sub_category }}</v-btn
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
export default {
  name: 'CategoryButtons',
  props: {
    categories: Array,
    subCategories: Boolean
  },
  computed: {
    activeSubCategoryName() {
      if (this.$route.name === 'SpeciesSubCategory') {
        return this.$route.params.subCategoryNameUrl
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="sss" scoped></style>
